import React, { useEffect, useState } from 'react'
import TabsHomePage from '../components/tabsHomePage/tabsHomePage'
import { useNavigate } from 'react-router-dom'
import { BufferService, LoadingBar } from 'src/components/M_Components'

export default function HomePage() {
    const navigate = useNavigate()
    const roleService = new BufferService('identity/userrole')
    const [isLoaded, setIsLoaded] = useState(true)
    const [permissions, setPermissions] = useState([])

    useEffect(() => {
        roleService.get().then(res => {
            if (res.name === 'AxiosError') {
                localStorage.removeItem("tokenMaeil")
                navigate('/login')
                setIsLoaded(false)
                return
            }
            if (res.User && res.Tenant && res.RoleDetails) {
                localStorage.setItem("roles", JSON.stringify(res.Role))
                localStorage.setItem("profile", JSON.stringify(res.User))
                localStorage.setItem("accountName", res.User.UserName)
                localStorage.setItem("accountCompany", res.Tenant)
                setPermissions(res.RoleDetails.map(roles => { return roles.Value }))
                setIsLoaded(false)
            } else {
                setIsLoaded(false)
                localStorage.removeItem("tokenMaeil")
                navigate('/login')
            }
        })
        // eslint-disable-next-line
    }, [])

    return (
        <>
            {isLoaded ? (<LoadingBar />) : (<TabsHomePage roles={permissions} />)}
        </>
    )
}